// extracted by mini-css-extract-plugin
export var md = "_5c-4";
export var semantic = "_5c-5";
export var sm = "_5c-3";
export var text = "_5c-6";
export var toggleInput = "_5c-0";
export var toggleSwitch = "_5c-1";
export var xs = "_5c-2";